module.exports = __webpack_public_path__ + "img/img_nav_bank_hover.d752c39e.svg";